<template>
  <div>
    <div class="flex flex-col items-center w-full md:w-3/4 mx-auto">
      <div v-for="harp in customerHarps" :key="harp.id" class="flex w-full items-center mb-4">
        <material-label  class=" mr-6 w-full" :value="harp.description" />
        <button class="hover:text-b2c-red-300 w-4" @click="deleteYourHarp(harp)">
          <bin-icon />
        </button>
      </div>
      <div class="w-full md:w-3/4 flex justify-between items-center" v-if="!addHarp" >
        <button class="p-4 px-6 rounded border border-b2c-grey-600 hover:bg-b2c-red-300 hover:text-white " @click="addHarp=true">{{$t('userData.addHarp')}} </button>
        <button class="p-4 px-6 rounded border border-b2c-grey-600 hover:bg-b2c-red-300 hover:text-white " @click="$emit('close')"> {{$t('userData.close')}} </button>
      </div>
    </div>

    <add-harp v-if="addHarp" :harps="harps" @added-harp="loadCustomerHarps()" @not-added="addHarp=false" />
  </div>
</template>

<script>
import MaterialLabel from '@/components/blocks/MaterialLabel.vue';
import AddHarp from '@/components/graphics/AddHarp.vue';
import BinIcon from '@/components/graphics/BinIcon.vue';
import {
  getCustomerHarps, deleteHarp, getHarps,
} from '@/services/HarpsService';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      addHarp: false,
      harps: [],
      customerHarps: [],
      newHarp: '',
    };
  },

  computed: {
    ...mapGetters({
      customer: 'auth/customer',
    }),
  },

  components: {
    MaterialLabel,
    AddHarp,
    BinIcon,
  },

  mounted() {
    this.loadCustomerHarps();
    getHarps().then(({ data }) => {
      this.harps = data;
    }).catch(() => {
      this.createNotification('error', `${this.$t('notifications.errorReload')}`);
    });
  },

  methods: {
    loadCustomerHarps() {
      this.addHarp = false;
      getCustomerHarps(this.customer.id).then(({ data }) => {
        this.customerHarps = data;
      }).catch(() => {
        this.createNotification('error', `${this.$t('notifications.errorReload')}`);
      });
    },

    deleteYourHarp(harp) {
      deleteHarp(harp.id, this.customer.id).then(() => {
        getCustomerHarps(this.customer.id).then((response) => {
          this.customerHarps = response.data;
          this.updatedHarps(true);
        }).catch(() => {
          this.createNotification('error', `${this.$t('notifications.errorReload')}`);
        });
      }).catch((error) => {
        this.checkSessionErrorNotification(error);
      });
    },
  },

};
</script>
